import forge from "node-forge";

const validateCertificate = async (file, password) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async (event) => {
      try {
        const buffer = event.target.result; // ArrayBuffer direto do FileReader
        const bytes = new Uint8Array(buffer);
        let binary = "";
        for (let i = 0; i < bytes.byteLength; i++) {
          binary += String.fromCharCode(bytes[i]);
        }

        const p12Asn1 = forge.asn1.fromDer(binary, false);
        let p12;

        // Tentar decifrar o P12 com a senha
        try {
          p12 = forge.pkcs12.pkcs12FromAsn1(p12Asn1, false, password);
        } catch (e) {
          console.error(">>> Erro na etapa pkcs12FromAsn1:", e);
          if (
            e.message &&
            (e.message.includes("password") ||
              e.message.includes("mac check") ||
              e.message.includes("MAC verify") ||
              e.message.includes("Decrypt final fail") ||
              e.message.includes("PKCS#12 MAC"))
          ) {
            return reject(new Error("Senha incorreta."));
          }
          // Se o erro não for de senha, pode ser corrupção ou formato inválido P12
          return reject(
            new Error(
              "Não foi possível decifrar o conteúdo P12/PFX. Verifique a senha ou se o arquivo está corrompido."
            )
          );
        }

        // Encontrar o saco (bag) que contém o certificado do usuário
        // Geralmente é o primeiro certificado encontrado que não é uma CA
        let userCert = null;
        const bags = p12.getBags({ bagType: forge.pki.oids.certBag });

        for (const bagType in bags) {
          for (const bag of bags[bagType]) {
            if (bag.cert && !bag.cert.isIssuer(bag.cert)) {
              // Tenta pegar o certificado que não é auto-assinado (não é a CA raiz no PFX)
              // Validação básica da estrutura do certificado
              if (
                bag.cert.subject &&
                bag.cert.validity &&
                bag.cert.serialNumber
              ) {
                userCert = bag.cert;
                break; // Para ao encontrar o primeiro certificado de usuário provável
              }
            }
          }
          if (userCert) break;
        }

        // Se não encontrou um certificado de usuário após o loop, tenta pegar o primeiro que encontrar
        if (!userCert && bags[forge.pki.oids.certBag]?.length > 0) {
          userCert = bags[forge.pki.oids.certBag][0].cert;
        }

        if (!userCert) {
          return reject(
            new Error(
              "Nenhum certificado de usuário encontrado no arquivo P12/PFX."
            )
          );
        }

      
        // Se chegou até aqui, a senha está correta e o CPF/CNPJ foi encontrado
        resolve({
          message: "Certificado validado com sucesso!",
          subject: userCert.subject.attributes.map((attr) => ({
            type: attr.shortName || attr.type,
            value: attr.value,
          })),
          issuer: userCert.issuer.attributes.map((attr) => ({
            type: attr.shortName || attr.type,
            value: attr.value,
          })),
          validity: {
            notBefore: userCert.validity.notBefore,
            notAfter: userCert.validity.notAfter,
          },
          hasCpfCnpj: true,
        });
      } catch (error) {
        // !!! IMPORTANTE: Logar o erro original para depuração !!!
        console.error(
          ">>> Erro Original da Biblioteca Forge ou Processamento:",
          error
        );
        console.error(">>> Mensagem do Erro Original:", error.message);
        // O stack trace também pode ser útil
        // console.error(">>> Stack Trace:", error.stack);

        // Mantém a lógica anterior, mas agora temos o log original no console
        if (
          error.message === "Senha incorreta." ||
          error.message.startsWith("Certificado válido, mas não contém") ||
          error.message.startsWith("Nenhum certificado")
        ) {
          reject(error); // Repassa os erros já tratados
        } else {
          // Continua rejeitando com a mensagem genérica para o usuário,
          // mas o desenvolvedor pode ver o erro real no console.
          reject(
            new Error(
              "Erro ao processar o certificado. Verifique se o arquivo é um P12/PFX válido e não está corrompido."
            )
          );
        }
      }
    };

    reader.onerror = (error) => {
      console.error("Erro ao ler o arquivo:", error);
      reject(new Error("Não foi possível ler o arquivo selecionado."));
    };

    // Lê o arquivo como ArrayBuffer, que é o formato esperado por forge
    reader.readAsArrayBuffer(file);
  });
};

export default validateCertificate;
